import axios from "axios";
import { useQuery } from "react-query";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getUltiproPeople = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/UltiproPeople`);
  return data;
};

export const useGetUltiproPeople = () => {
  return useQuery("UltiproPeople", getUltiproPeople, {
    refetchOnWindowFocus: false,
  });
};
